/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { useSetAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import React, { useEffect } from 'react'

import { initialiseCountryAtom } from '@/store/country'
import { Geolocation, geolocationAtom } from '@/store/geolocation'

/** A description of the available properties for this component. */
type GeolocationHydrationProps = Geolocation

/**
 * Hydrates the geolocation atom with the geolocation data from the provided properties. It also initialises the country
 * on first load if needed.
 */
const GeolocationHydration: React.FC<GeolocationHydrationProps> = ({ country }) => {
  const initialiseCountry = useSetAtom(initialiseCountryAtom)
  useHydrateAtoms([[geolocationAtom, { country }]])

  /**
   * Initialises the country on first load if needed.
   */
  useEffect(() => {
    initialiseCountry()
  }, [initialiseCountry])

  return null
}

export { GeolocationHydration }
